// mock Flash messgaae for web version, because react-flash-message is not supported for web
import { Fragment as FlashMessage } from "react";

export default FlashMessage;